import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bz3k507h6: FaireProductEntity = {
  token: "p_3bz3k507h6",
  type: "product",
  name: "Natural Bath Bomb handmade - Just Calm Down - Bath Gifts",
  brandToken: "b_2oar1fmd",
  brandName: "Evolve Botanica",
  imageUrl:
    "https://cdn.faire.com/fastly/cc5cf88c0518aed0fb62790e2409588e2652be7ce792fdfc39a003851ba837e7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f847ebcf56b5158a0767850e8c999aeeedc670588962901d879c21257b2cba85.png",
    "https://cdn.faire.com/fastly/bc76789650df38159a40ee509dcc177e016903249e14d09b7b5d4c5cf8a7334f.png",
    "https://cdn.faire.com/fastly/ba206e176c42d61186b3126688b739b231359fbda1cb7a7aecd2de837f26f581.png",
  ],
  priceDollars: 3.5,
  description:
    "Experience the crisp and clean scent of our Bath Bomb - Just Calm Down. This bath bomb features an earthy, grounding fragrance with a touch of lavender, perfect for a relaxing and soothing bath. Crafted with high-quality ingredients, including Sodium Bicarbonate, Citric Acid, Sea Salt, Sunflower Oil, Fragrance Oil, Natural Shea Butter, and Colorant, these bath bombs are ideal for summertime, Easter baskets, and self-care gifts.\n\nFeature Highlights:\n\nMade with natural ingredients for a calming and luxurious bath experience.\nIdeal for the summer season with an earthy and lavender scent.\nPerfect for Easter baskets, summer gifts, and self-care presents.\nGentle on sensitive skin with moisturizing Shea Butter.\nAvailable in bulk, wholesale, and private label options for retailers.\nEntice your customers with the calming aroma and luxurious feel of these natural summer bath bombs, perfect for gifting and self-care.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:17.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
